/**
 * Runtime config is fetched from /runtime-config.json (written by the CDK
 * frontend stack at deploy time). This lets us change User Pool IDs, Gateway
 * URLs, etc. without rebuilding the bundle.
 */
export interface RuntimeConfig {
  appName: string;
  /** Admin email (from APP_CONFIG.admin.email). Used by the "coming soon" gate
   *  to decide who sees the real app. Cosmetic only — the API enforces admin
   *  server-side from the verified JWT claim. */
  adminEmail: string;
  region: string;
  userPoolId: string;
  userPoolClientId: string;
  cognitoDomain: string;
  gatewayUrl: string;
  profileApiUrl: string;
  /** Lambda Function URL with RESPONSE_STREAM for /chat/{agent} and
   *  /collaborate. Lets the browser see NDJSON tokens as they're emitted
   *  instead of waiting for a full buffered response. */
  streamUrl: string;
  ui: { theme: "dark"; tabs: readonly ("claude" | "gemini" | "grok" | "collaborator")[] };
  rateLimits: {
    singleAgentMessagesPerDay: number;
    quickCollaboratePerDay: number;
    deepDebatePerDay: number;
    warnAtPercent: number;
  };
  collaborator: { round3EnabledByDefault: boolean };
}

let _cfg: RuntimeConfig | null = null;

export async function loadRuntimeConfig(): Promise<RuntimeConfig> {
  if (_cfg) return _cfg;
  const res = await fetch("/runtime-config.json", { cache: "no-store" });
  if (!res.ok) throw new Error(`Failed to load runtime config: ${res.status}`);
  _cfg = (await res.json()) as RuntimeConfig;
  return _cfg;
}

export function getRuntimeConfig(): RuntimeConfig {
  if (!_cfg) throw new Error("Runtime config not loaded yet");
  return _cfg;
}
